module.exports = __webpack_public_path__ + "img/2.26c7a371.png";